
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student",
      function () {
        return require("private-next-pages/student/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student"])
      });
    }
  